import React, { useEffect, useReducer, useState } from 'react';

import { useAuth } from '../../Context';
import { Content } from 'antd/es/layout/layout';
import { Avatar, Button, Card, Col, Empty, Form, Input, message, Modal, Popover, Row,  Space, Spin,  Table,  Typography } from 'antd';
import {  DeleteOutlined, EditOutlined, InfoOutlined, PlusOutlined, StockOutlined } from '@ant-design/icons';
import englan from '../../../english.json';
import germanlan from '../../../german.json';
import arabiclan from '../../../arabic.json';
import frenchlan from '../../../french.json';
import hindilan from '../../../hindi.json';
import malayalamlan from '../../../malayalam.json';
import axios from 'axios';
import PredicitonlevelManagementReducer from './reducer';
import { PREDICTION_LEVEL_LIST, PREDICTION_LEVEL_LIST_SUCCESS, PREDICTION_LEVEL_LIST_ERROR, ADD_PREDICTION_LEVEL, ADD_PREDICTION_LEVEL_SUCCESS, ADD_PREDICTION_LEVEL_ERROR, PREDICTION_LEVEL_UPDATE, PREDICTION_LEVEL_UPDATE_SUCCESS, PREDICTION_LEVEL_UPDATE_ERROR, PREDICTION_LEVEL_DETAILS, PREDICTION_LEVEL_DETAILS_ERROR, PREDICTION_LEVEL_DETAILS_SUCCESS, DELETE_PREDICTION_LEVEL, DELETE_PREDICTION_LEVEL_SUCCESS, DELETE_PREDICTION_LEVEL_ERROR } from './constants';
import { useFormik } from 'formik';
import { useNavigate } from 'react-router-dom';
// import { Option } from 'antd/es/mentions';


const { Title } = Typography;

export default function PredictionLevel() {
	const dashboardtype = process.env.REACT_APP_IDENTIFIER;
	const authtoken = localStorage.getItem(`${dashboardtype.toUpperCase()}_ACCESS_TOKEN`);
	const initalState = { loading: false, error: false,details:null, predictionlevel : [], pagination: { total: 0, limit: 10, skip: 0, current:1 }};
	const [data, dispatch] = useReducer(PredicitonlevelManagementReducer, initalState);
	const [isAddModalOpen, setIsAddModalOpen] = useState(false);
	const [openEditDrawer, setOpenEditDrawer] = useState(false);
	const [showDeletepredicitonlevelModal, setShowDeletepredictionlevelModal] = useState(false);
	
	const featuresModule = JSON.parse(localStorage.getItem(`${dashboardtype.toUpperCase()}_FEATURES_MODULE_DASHBOARD`));

	const permission = localStorage.getItem(`${dashboardtype.toUpperCase()}_PERMISSION`);
	

	const langid = localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) && localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) ? parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`)) : 2;
	const langdata = langid && langid ==1 ? arabiclan : langid ==2 ? englan : langid ==3 ? frenchlan : langid ==4 ? germanlan : langid ==5 ? hindilan : langid == 6 ? malayalamlan : englan;
	const apiUrl = localStorage.getItem(`${dashboardtype.toUpperCase()}_API_URL`);
	const api = apiUrl && apiUrl ? apiUrl : process.env.REACT_APP_CORE_HOST;	
	const envTimeout = process.env.REACT_APP_TIMEOUT == undefined || process.env.REACT_APP_TIMEOUT == 'undefined' ? 5000 : process.env.REACT_APP_TIMEOUT;
	const timeout = localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'undefined' ? parseInt(envTimeout) :  parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`));
	
	const navigate = useNavigate();
	
	useAuth();
	
	useEffect(() => {
		if(!authtoken){
			navigate('/');
		}
		if(featuresModule.predictionlevelEnabled == false) {
			navigate('/dashboard');
		}
		window.scrollTo(0, 0);
		localStorage.setItem(dashboardtype.toUpperCase()+ '_ACTIVE_MENU_ITEM' ,4027);
		loadpredicitonlevel();
	}, []);
	
	
	const loadpredicitonlevel= ()=>{
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/predictionlevel/?&$sort[id]=-1`,
			timeout: timeout,
			headers: { 
				'Content-Type': 'application/json', 
				Authorization:`Bearer ${authtoken}`				
			},
		};
		dispatch({type : PREDICTION_LEVEL_LIST});
		axios.request(config)
			.then((response) => {
				if(response.status == 200 || response.status == 201){	
									
					dispatch({ type : PREDICTION_LEVEL_LIST_SUCCESS, payload: response.data.data });
				} else {
					dispatch({ type : PREDICTION_LEVEL_LIST_ERROR});			
				}
			})
			.catch((error) => {
				console.log(error);
				dispatch({ type : PREDICTION_LEVEL_LIST_ERROR });
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				} else {
					// Modal.warning({ title: langdata && langdata.Unabletoupdatealgorithm ? langdata.Unabletoupdatealgorithm : 'Unable to update algorithm.' });											
				}
			});
	};

	const deltehandler = (record) =>{
		loadPredictionlevelDetails(record);
		openDeletepredictionlevelModal();
	};

	const edithandler = (record) =>{
		loadPredictionlevelDetails(record);
		showEditDrawer();
	};

	const openDeletepredictionlevelModal = () => {
		// setShowDeleteGeofenceManagementModal(true);
		setShowDeletepredictionlevelModal(true);
	};
		
	const closeDeletepredictionlevelModal = () => {
		setShowDeletepredictionlevelModal(false);
	};

	const deletepredictionlevel = () => {
		const id = parseInt(data.details.id);
			
		dispatch({ type: DELETE_PREDICTION_LEVEL });
		
		let config = {
			method: 'delete',
			maxBodyLength: Infinity,
			url: `${api}/predictionlevel/${id}`,
			timeout: timeout,
			headers: {
				accept: 'application/json',
				'Content-Type': 'application/json',
				Authorization:`Bearer ${authtoken}`
			}
		};
		
		axios
			.request(config)
			.then((response) => {
				if (response.status === 200) {
					dispatch({type: DELETE_PREDICTION_LEVEL_SUCCESS, payload: response});
					setShowDeletepredictionlevelModal(false);   
					loadpredicitonlevel();       
				} else {
					dispatch({type:DELETE_PREDICTION_LEVEL_ERROR});  
				}
			})
			.catch((error) => {
				dispatch({type:DELETE_PREDICTION_LEVEL_ERROR});
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				}
			});
	};


	const columns = [
		{
			title: langdata && langdata.Name ? langdata.Name : 'Name',
			dataIndex: 'name',
			key: 'name',
			width : 200
		},
		{
			title: `${langdata && langdata.Actions ? langdata.Actions:'Actions'}`,
			key: '',
			align:'center',
			width : 100,

			render: (_,record) => (
						
		
				<>
					<Space style={{justifyContent:'center',display:'flex'}} size="middle">
						<a title={langdata && langdata.Edit ? langdata.Edit:'Edit'}  onClick={()=>edithandler(record)}><EditOutlined/></a>
						<a title={langdata && langdata.Delete ? langdata.Delete :'Delete'} onClick={()=>deltehandler(record)}><DeleteOutlined /></a>

					</Space>
				</>
			)
		}
	];

	const handleOk = () => {
		setIsAddModalOpen(false);
		createFormik.resetForm();
	};
	const handleCancel = () => {
		setIsAddModalOpen(false);
		createFormik.resetForm();

	};
	const showEditDrawer = () => {
		setOpenEditDrawer(true);
		formik.resetForm();
	};	
	const handleModalCancel = () => {
		setOpenEditDrawer(false);
		formik.resetForm();
	};

	const createFormik = useFormik({
		// enableReinitialize: true,
		initialValues : {
			name : null,
			
			
		},
		onSubmit: (values) => {
			
			if( name == null){
				Modal.warning({title : langdata && langdata.Pleasefillallthefields ? langdata.Pleasefillallthefields : 'Please fill all the fields'});
				return false;
			}
		
			
			dispatch({ type : ADD_PREDICTION_LEVEL });
			let data = JSON.stringify({
				'name' : values.name,
				
			});

			let config = {
				method: 'post',
				maxBodyLength: Infinity,
				url: `${api}/predictionlevel`,
				timeout: timeout,
				headers: { 
					'Content-Type': 'application/json', 
					Authorization:`Bearer ${authtoken}`				},
				data : data
			};

			axios.request(config)
				.then((response) => {
					if(response.status == 200 || response.status == 201){	
						Modal.success({ title: langdata && langdata.PredictionlevelAddedSuccessfully ? langdata.PredictionlevelAddedSuccessfully : 'Prediction level Added Successfully' });	
									
						dispatch({ type : ADD_PREDICTION_LEVEL_SUCCESS  } );
						loadpredicitonlevel();	
						createFormik.resetForm();
						setIsAddModalOpen(false);
					} else {
						dispatch({ type : ADD_PREDICTION_LEVEL_ERROR });
						Modal.warning({ title: langdata && langdata.Unabletoadd ? langdata.Unabletoadd : 'Unable to add' });					
					}
				})
				.catch((error) => {
					console.log(error);
					dispatch({ type : ADD_PREDICTION_LEVEL_ERROR });
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
						});
					} else {
						Modal.warning({ title: langdata && langdata.Unabletoadd ? langdata.Unabletoadd : 'Unable to add' });					
					}
				});

		}
	});	

	const infoContent = (
		<Card size="small" bordered="false" type="inner" style={{ width: 300 }}> 
			<p style={{textAlign:'justify'}}> {langdata && langdata.predictionModuleInfo ? langdata.predictionModuleInfo : 'This module is used to manage different types of prediction levels.'} </p>
		</Card>
	);

	const formik = useFormik({
		enableReinitialize: true,
		initialValues: {
			name:  data?.details?.name || '',
		},
		onSubmit: (values) => {
		
			dispatch({type:PREDICTION_LEVEL_UPDATE});
			let config = {
				method: 'patch',
				maxBodyLength: Infinity,
				url: `${api}/predictionlevel/${data?.details?.id}`,
				timeout: timeout,
				headers: {
					accept: 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${authtoken}`
				},
				data: {
					name : values.name,
					
				}
			}; 
			axios
				.request(config)
				.then((response) => {
					if (response.status === 200) {

						dispatch( { type: PREDICTION_LEVEL_UPDATE_SUCCESS, payload: response.data.data });
						Modal.success({ title: `${langdata && langdata.PredictionlevelUpdatedSuccessfully ? langdata.PredictionlevelUpdatedSuccessfully :'Prediction level Updated Successfully'}` });
						formik.resetForm();
						setOpenEditDrawer(false);
						loadpredicitonlevel();
					}
				})
				.catch((error) => {
					console.log(error);
					dispatch({ type: PREDICTION_LEVEL_UPDATE_ERROR});
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content:  `${langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :'It seems the network is unreachable. Please refresh the application.'}`,
						});
					}
				});
	
		}
	});

	const loadPredictionlevelDetails = ((record) => {
		dispatch( { type: PREDICTION_LEVEL_DETAILS });
			
		if (!record) {
			dispatch({ type: PREDICTION_LEVEL_DETAILS_ERROR });
		} else {
			dispatch({ type: PREDICTION_LEVEL_DETAILS_SUCCESS, payload: record });
		
		}
		
	});

	return (
		<Content>
			<Row style={{
				margin: '10px',
				paddingLeft: '10px',
				paddingRight: '10px',
				background: '#FFFFFF',
				alignItems:'center',
			}}
			>
				<Col span={8}>
					<Row>
						<Space>
							<StockOutlined style={{fontSize:'30px'}}/>
						</Space>
						<Space>&nbsp;&nbsp;</Space>
						<Title level={4} style={{ paddingTop:'10px'}}>{langdata && langdata.PredictionLevel ? langdata.PredictionLevel : 'Prediction Level'}</Title>
					</Row>
				</Col>
				<Col span={16}>
					<Row justify="end">
						<Col>
							{/* <Text style={{ display: 'flow', paddingTop: '4px', textAlign: 'end',  marginRight: '4px' }}>User Type:</Text> */}
							{ permission==='superadmin' || permission === 'admin' ? 
								<Space>
									<Space>&nbsp;</Space>
									<Button style={{margin:'5px'}} type="primary" onClick={() => {setIsAddModalOpen(true);}}><PlusOutlined/>{langdata && langdata.AddNew ? langdata.AddNew : 'Add New'}</Button>
								</Space>
								: null }
							<Space>&nbsp;&nbsp;&nbsp;</Space>
							
							<Popover title={langdata && langdata.PredictionLevel ? langdata.PredictionLevel : 'Prediction Level'}  content={infoContent} trigger="click">
								<Avatar size="small"><InfoOutlined/></Avatar>
							</Popover>
						</Col>
					</Row>
				</Col>
			</Row>
			<Row span={24} style={{
				margin: '10px',
				paddingLeft: '10px',
				paddingRight: '10px',
				background: '#FFFFFF',
				alignItems:'center'
			}} >
				<Col span={24}>
					{ data.predictionlevel && data.predictionlevel && data.predictionlevel.length > 0 ? (
						<Table
							scroll={{
								x: 900,
							}}
							columns = { columns } 
							dataSource = { data.predictionlevel } 
							onChange={loadpredicitonlevel}
							onRow = {() => {
								return {
									onClick: () => { 
										// loadPredictionlevelDetails(record);

												
									}
								};
							}}
						/>
					)
						:
						(
							<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
						)}
				</Col>
			</Row>


			<Modal
				title={langdata && langdata.AddPredictionLevel ? langdata.AddPredictionLevel : 'Add Prediction Level'}
				centered
				open={isAddModalOpen}
				onOk={handleOk}
				onCancel={handleCancel}
				maskClosable={false}
				destroyOnClose= {true}
				footer={[
					// eslint-disable-next-line react/jsx-key
					<Space>
						<Button onClick={handleCancel}>{langdata && langdata.CLOSE ? langdata.CLOSE : 'CLOSE'}</Button>
						<Button type="primary"  onClick={createFormik.handleSubmit}>{langdata && langdata.SAVE ? langdata.SAVE : 'SAVE'}</Button>
					</Space>
				]}
				width={500}
			>
				<Form layout="vertical" >
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item label={langdata && langdata.Name ? langdata.Name : 'Name'} rules={[{ required: true, message: langdata && langdata.Pleasefillthename ? langdata.Pleasefillthename : 'Please fill the name' }]} required>
								<Input 
									name="name" 
									placeholder={langdata && langdata.Pleasefillthename ? langdata.Pleasefillthename : 'Please fill the name'}
									onChange={createFormik.handleChange} 
								/>
							</Form.Item>
						</Col>
					</Row>
					
				</Form>
			</Modal>

			<Modal
				title={langdata && langdata.EditPredictionLevel ? langdata.EditPredictionLevel:'Edit Prediction Level'}
				width={500}
				centered
				destroyOnClose={true}
				maskClosable={false}
				onOk={formik.handleSubmit}
				onCancel={handleModalCancel}
				open={openEditDrawer}
				styles={{
					body: {
					},
				}}
				footer={[
					// eslint-disable-next-line react/jsx-key
					<Space>
						<Button onClick={handleModalCancel}>
							{langdata && langdata.CANCEL ? langdata.CANCEL:'CANCEL'}
						</Button>
						<Button onClick={formik.handleSubmit} type="primary">
							{langdata && langdata.SAVE ? langdata.SAVE:'SAVE'}
						</Button>
					</Space>
				]}
			>
				<Form onSubmit={formik.handleSubmit} layout="vertical"
					
				>
					<Row gutter={24}>
						<Col span={24}>
							<Form.Item label={langdata && langdata.Name ? langdata.Name:'Name'} rules={[{ required: false, message: `${langdata && langdata.Name ? langdata.Name:'Name'}` }]}>
								<Input name="name" value={formik.values.name} onChange={formik.handleChange} defaultValue={data?.details?.name}  placeholder={langdata && langdata.Name ? langdata.Name:'Name'} />
							</Form.Item>
						</Col>
					</Row>
				</Form>
			</Modal>
			<Modal title={langdata && langdata.Confimdelete ? langdata.Confimdelete : 'Confirm delete'} open={showDeletepredicitonlevelModal} onOk={deletepredictionlevel} onCancel={closeDeletepredictionlevelModal}>
				<Row style={{
					marginTop: '10px',
					marginBottom: '10px',
					background: '#FFFFFF',
					alignItems:'center'
				}} >
					<Col span={1}>
						<DeleteOutlined  style={{ fontSize: '14px'}}/>
					</Col>
					<Col span={23}> { langdata && langdata.Areyousureyouwanttodeletethis ? langdata.Areyousureyouwanttodeletethis : 'Are you sure you want to delete this' }</Col>
				</Row>
			</Modal>
			<Spin fullscreen spinning={data.loading} />
		</Content>
	);
}